import { OwnersListFilterInput } from 'gql/types';
import { TFunction } from 'i18next';
import { FiltersConfig } from 'modules/common/components/FilterChips/types';
import { formatEnum } from 'modules/common/utils/formatEnum';

export const createOwnerListChipsConfig = (
  t: TFunction
): FiltersConfig<OwnersListFilterInput> => ({
  ownerTypes: {
    label: t('ownerType'),
    renderValue: formatEnum,
  },
  locationPreferences: {
    label: t('location'),
  },
});

export const excludedFilterFields: (keyof OwnersListFilterInput)[] = [
  'searchingQuery',
  'isArchived',
  'isDeleted',
  'username',
];
